import React, { useState } from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';
import GolferAuthLayout from './GolferAuthLayout';

const ForgotUsername = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleForgotUsername = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post('https://lionfish-app-w73zu.ondigitalocean.app/api/forgot_username/', { email });
      setMessage(response.data.message || "If the email exists, you will receive an email with your username.");
    } catch (error) {
      console.error("Username recovery request failed:", error);
      setMessage("An error occurred while requesting username recovery.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <GolferAuthLayout
      seoTitle="Forgot Username — PrivateIQ"
      seoDescription="Recover your PrivateIQ username."
      canonicalPath="/forgot-username"
    >
      <div className="ga-auth-card">
        <div className="ga-auth-badge">Account Recovery</div>
        <h1 className="ga-auth-title">Forgot Username?</h1>
        <p className="ga-auth-subtitle">
          Enter the email address associated with your account and we'll send you your username.
        </p>
        <form onSubmit={handleForgotUsername} className="ga-auth-form">
          <input
            className="ga-auth-input"
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" className="ga-auth-btn" disabled={loading}>
            {loading ? "Sending..." : "Send Username"}
          </button>
          {message && (
            <p className={message.includes("error") ? "ga-auth-error" : "ga-auth-message"}>
              {message}
            </p>
          )}
        </form>
        <div className="ga-auth-links">
          <p>
            Remembered your username? <Link to="/login">Login</Link>
          </p>
          <p>
            Forgot your password? <Link to="/forgot-password">Reset Password</Link>
          </p>
        </div>
      </div>
    </GolferAuthLayout>
  );
};

export default ForgotUsername;
